import notDeleted from '../notDeleted';

/**
 * Checks whether every (non-deleted) matrix row of a question has been answered.
 * Used by the public questionnaire to block "Volgende" on MSI matrix questions
 * until all rows are filled (docs/features/datakwaliteitsscore.md, T1).
 *
 * @param {Array<{RowID?: string, Input?: string}>} fieldResponses - Response entries of one field from the Responses context
 * @param {Array<{ID: string, Deleted?: boolean|string}>} rows - MatrixQuestionRows docs of that field
 * @returns {{complete: boolean, missingRowIds: string[]}} Completion state and the row IDs still unanswered
 */
const matrixRowsComplete = (fieldResponses, rows) => {
    const requiredRows = (rows || []).filter(notDeleted);

    const answeredRowIds = new Set(
        (fieldResponses || [])
            .filter((response) =>
                response?.RowID &&
                response.Input !== '' &&
                response.Input !== undefined &&
                response.Input !== null
            )
            .map((response) => response.RowID)
    );

    const missingRowIds = requiredRows
        .filter((row) => !answeredRowIds.has(row.ID))
        .map((row) => row.ID);

    return { complete: missingRowIds.length === 0, missingRowIds };
};

export default matrixRowsComplete;
